import { createAsyncThunk } from "@reduxjs/toolkit";
import { NoticeService } from "@services/index";
import { getBaseUrl } from "../selectors/features";
import {
  FETCH_NOTICES,
  DELETE_NOTICE,
  ADD_NOTICE,
  UPDATE_NOTICE,
  FETCH_PUBLISH_NOTICES,
  PING_NOTICE,
} from "../action-types/notice";

const noticeService = new NoticeService();

export const getNotices = createAsyncThunk<TObject, TObject, IActionOptions>(
  FETCH_NOTICES,
  async (requestPayload: any, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { onError, onSuccess, search, limit, offset, slug } = requestPayload;

    const { data, error } = await noticeService.getNotices(baseUrl, {
      search,
      limit,
      offset,
      slug: slug ?? "",
    });

    if (error) {
      onError(error, FETCH_NOTICES);
      return thunkAPI.rejectWithValue(error);
    } else {
      onSuccess(
        { rows: data?.rows, count: data?.count, data: data },
        FETCH_NOTICES
      );
    }
    return thunkAPI.fulfillWithValue(data);
  }
);

export const getPublishNotices = createAsyncThunk<
  TObject,
  TObject,
  IActionOptions
>(FETCH_PUBLISH_NOTICES, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, search, limit, offset, noticeTypeId, slug } =
    requestPayload;

  const { data, error } = await noticeService.getPublishNotices(baseUrl, {
    search,
    limit,
    offset,
    noticeTypeId,
    slug: slug ?? "",
  });

  if (error) {
    onError(error, FETCH_PUBLISH_NOTICES);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(
      { rows: data?.rows, count: data?.count, data: data },
      FETCH_PUBLISH_NOTICES
    );
  }
  return thunkAPI.fulfillWithValue(data);
});

export const doAddNotice = createAsyncThunk<TObject, TObject, IActionOptions>(
  ADD_NOTICE,
  async (requestPayload: any, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { onError, onSuccess, payload } = requestPayload;
    console.log("doAddNotice: baseUrl=", baseUrl, "payload=", payload);
    const { data, error } = await noticeService.addNotice(baseUrl, payload);
    if (error) {
      onError(data, ADD_NOTICE);
      return thunkAPI.rejectWithValue(error);
    } else {
      onSuccess(data, ADD_NOTICE);
    }
    return thunkAPI.fulfillWithValue(data);
  }
);

export const deleteNotice = createAsyncThunk<TObject, TObject, IActionOptions>(
  DELETE_NOTICE,
  async (requestPayload: any, thunkAPI) => {
    const baseUrl = getBaseUrl(thunkAPI.getState());
    const { onError, onSuccess, id, paymentRemovalSuccess } = requestPayload;

    const { data, error } = await noticeService.deleteNotice(baseUrl, id);

    if (error) {
      onError(error, DELETE_NOTICE);
      return thunkAPI.rejectWithValue(error);
    } else {
      onSuccess(data?.rows, DELETE_NOTICE, paymentRemovalSuccess);
    }
    return thunkAPI.fulfillWithValue(data);
  }
);

export const updateNotice = createAsyncThunk<
  TObject,
  { payload: any; id: number; onError: any; onSuccess: any },
  IActionOptions
>(UPDATE_NOTICE, async (requestPayload: any, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { onError, onSuccess, payload, id } = requestPayload;

  const { data, error } = await noticeService.updateNotice(
    baseUrl,
    payload,
    id
  );

  if (error) {
    onError(error, UPDATE_NOTICE);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, UPDATE_NOTICE);
  }
  return thunkAPI.fulfillWithValue(data);
});

export const pinNotice = createAsyncThunk<
  TObject,
  { id: number; pin: boolean; onError: any; onSuccess: any },
  IActionOptions
>(PING_NOTICE, async (requestPayload, thunkAPI) => {
  const baseUrl = getBaseUrl(thunkAPI.getState());
  const { id, pin, onError, onSuccess } = requestPayload;
  const { data, error } = await noticeService.pinNotice(baseUrl, id, pin);
  if (error) {
    onError(error, PING_NOTICE);
    return thunkAPI.rejectWithValue(error);
  } else {
    onSuccess(data, PING_NOTICE);
  }
  return thunkAPI.fulfillWithValue(data);
});
